const TUEV_ZERTIFIKAT = "https://m.certipedia.com/?id=9108624207"

const RHLD_IMPRESSUM = "https://www.rheinland-versicherungen.de/impressum/";

const RHLD_DATENSCHUTZ = "https://www.rheinland-versicherungen.de/datenschutz/";

const RHLD_NUTZUNGSBEDINGUNGEN = "https://www.rheinland-versicherungen.de/nutzungsbedingungen/";

const RHLD_PORTRAITS_DEFAULT = "https://legacy.rheinland-versicherungen.de/fileadmin/Dateiliste/Bilder/LinkedApp_Portraits/portrait_mann.jpg";

const RHLD_PORTRAITS = "https://legacy.rheinland-versicherungen.de/fileadmin/Dateiliste/Bilder/LinkedApp_Portraits";

const ExternalUrls = {
    TUEV_ZERTIFIKAT,
    RHLD_IMPRESSUM,
    RHLD_DATENSCHUTZ,
    RHLD_NUTZUNGSBEDINGUNGEN,
    RHLD_PORTRAITS_DEFAULT,
    RHLD_PORTRAITS,
}

export default ExternalUrls;